// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + chunkId + "." + {"67":"5646878485643d61f1f2","315":"9913a185993752734b82"}[chunkId] + ".js";
};